import React, { useEffect, useState } from 'react';
import Icon, { COLORS, ICONS } from '../icon';
import classNames from 'classnames';
import { Chip, ChipOption, CustomChips, ProfileChips } from '../../types/stylepacks';
import { ChipContext } from '../../../contexts/generated-content/content-chip-context';
import { GreenroomState } from '../../../stores/types/types';
import { useSelector } from 'react-redux';
import useProfile from '../../../hooks/use-profile';

interface OwnProps {
	expanded: boolean;
	callback: (e: {target: {value: string, name: string}}) => void;
	dataKey: string
}

export default function GrInputDropdown(props: OwnProps) {
	const {expanded, callback, dataKey} = props;
	const invitations = useSelector((s: GreenroomState) => s.InvitationsReducer.invitations);
	const {getMaskedProfileById} = useProfile({});
	const {attachChip, clearChip, chipsetUserId, chipMap} = React.useContext(ChipContext);
	
	const fieldChipType = chipMap.get(dataKey)?.chip_type ?? Chip.custom;
	const [active, setActive] = useState(fieldChipType)
	useEffect(() => {
		setActive(fieldChipType)
	}, [fieldChipType])

	const toggleChip = (chip: ChipOption, active: Chip) => {
		if (chip.type === Chip.custom || active === chip.type) {
			clearChip(dataKey);
			setActive(Chip.custom);
		} else {
			const str = chip.type === Chip.full_name
				? `${userProfile?.first_name ?? ''} ${userProfile?.last_name ?? ''}`
				: (userProfile as Record<string, any>)?.[chip.type] ?? '';
			attachChip(dataKey, chip.type);
			setActive(chip.type);
			callback({target:{value:str,name:dataKey}});
		}
	}
	
	const userProfile = React.useMemo(() => {
		const mask = getMaskedProfileById(chipsetUserId ?? 0);
		if (mask) return mask;
		const userInvite = invitations.find((i) => i.profile.gr_user === chipsetUserId);
		return userInvite?.profile;
	}, [invitations, getMaskedProfileById, chipsetUserId])

	if (!userProfile) return null;

	return <div className={classNames('gr-input-dropdown-container', {expanded})}>
		<div className='flex-align-center' style={{gap: '4px'}}>
			<Icon name={ICONS.LINK2} color={COLORS.TEXT_GRAY_400} size={16}/>
			<h6 className='bl-font-header margin-bottom-medium text-gray-400'>User Data</h6>
		</div>
		<div className='gr-input-chip-list'>
			{ProfileChips.map((c) => (
				<div
					key={`${c.label}-${c.type}`}
					onClick={() => toggleChip(c, active)}
					className={`gr-input-chip ${active === c.type ? 'chip-active' : ''}`}
				>
					<Icon name={c.icon} size={12} color={COLORS.WHITE}/>
					<span className='bl-font-l3 text-container'>{c.label}</span>
				</div>
			))}
		</div>
		<h6 className='bl-font-header margin-bottom-medium text-gray-400'>Other</h6>
		<div className='gr-input-chip-list'>
			{CustomChips.map((c) => (
				<div
					key={`${c.label}-${c.type}`}
					onClick={() => toggleChip(c, active)}
					className={`gr-input-chip ${active === c.type ? 'chip-active' : ''}`}
				>
					<Icon name={c.icon} size={16} color={COLORS.WHITE}/>
					<span className='bl-font-l3 text-container'>{c.label}</span>
				</div>
			))}
		</div>
	</div>
}
